module.exports = __webpack_public_path__ + "img/Cover_FS_20.38ee5012.jpg";